/**
 * @fileoverview Custom Pagination Module for InstantSearch.js.
 * Defines a custom pagination connector and rendering function for use with InstantSearch.js.
 */

import { connectPagination } from 'instantsearch.js/es/connectors';
import {addParamToUrl, getContentTypeFromUrl, scrollToDiv} from "../../Utils";
/**
 * Renders a custom pagination widget.
 * This function is used as a connector for the pagination widget in InstantSearch.js.
 * It creates a pagination UI with previous and next buttons, and displays the current page number and total pages.
 *
 * @param {Object} renderOptions - The options and utilities provided by InstantSearch.js for rendering the pagination widget.
 * @param {boolean} isFirstRender - Indicates if this is the first render of the pagination widget.
 */
const renderPagination = (renderOptions, isFirstRender) => {
    const paginationContainer = '#pagination';
    const {
        currentRefinement,
        nbPages,
        isFirstPage,
        refine,
        createURL,
    } = renderOptions;
    const container = document.querySelector(paginationContainer);
    const pages =  window.results?.nbPages || nbPages;
    const page = window.results?.page || currentRefinement;
    container.innerHTML = `
    <div class="w-full max-w-[1684px] flex justify-between mt-4">
        <div>
            <a href="${createURL(currentRefinement - 1)}" data-value="${currentRefinement - 1}" 
              class="${isFirstPage ? 'invisible' : ''}" >
              <div class="flex items-center btn-searcher btn">
                    <button class="flex items-center inner-button">
                        <div class="relative mr-6 hidden lg:flex items-center justify-center overflow-hidden">
                           <svg class="btn-arrow-reverse" width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15.2255 8H1.05957M1.05957 8L8.14256 15M1.05957 8L8.14256 1" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        Previous
                    </button>
                </div>
            </a>
        </div>
        <div>
            Page ${currentRefinement + 1} of <span id="nbPages">${ pages }</span>
        </div>
        <div>
            <a href="${createURL(currentRefinement + 1)}" data-value="${currentRefinement + 1}" 
              class="${page === pages - 1 || pages === 0 ? 'invisible' : ''}" id="nextButton">
                <div class="flex items-center btn-searcher btn">
                    <button class="flex items-center inner-button">
                        Next
                        <div class="relative ml-6 hidden lg:flex items-center justify-center overflow-hidden">
                            <svg class="btn-arrow" width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.78617 8L15.9521 8M15.9521 8L8.86916 0.999999M15.9521 8L8.86916 15" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                    </button>
                </div>
            </a>
        </div>
    </div>
  `;
    // TODO: Improve this code
    [...container.querySelectorAll('a')].forEach(element => {
        element.addEventListener('click', event => {
            event.preventDefault();
            const currentType = getContentTypeFromUrl()
            if (event.currentTarget.dataset.value) {
                refine(event.currentTarget.dataset.value);
                setTimeout(() => {
                    addParamToUrl('content_type', currentType);
                }, 500);
            }

            const { topContainer } = renderOptions.widgetParams;
            if (topContainer) {
                scrollToDiv(topContainer);
            }

        });
    });
};

/**
 * Custom Pagination Connector using InstantSearch.js's connectPagination.
 * This creates a custom pagination widget for InstantSearch.js implementations.
 */
const customPaginationMultiIndex = connectPagination(renderPagination);

export default customPaginationMultiIndex;